<template>
	<div ref="idPan" style="height:100%;">
		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>

		<div style="flex: 0 0 auto; width:100%; height:50px;">
			<div class="SiftPanel">
				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('客户名称')}}</div>
				<input type="text" style="width:120px;" maxlength=30 v-model="findCustName">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('授权方式')}}</div>
				<cselect style="position:relative; height:30px; min-width:80px; z-index:999;" :defv="findAuthType" v-model="findAuthType" :ctrl="ctrlAuthType" :csData="dataAuthType"></cselect>

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('权益')}}</div>
				<cselect style="position:relative; height:30px; min-width:80px; z-index:999;" :defv="findEquityLevel" v-model="findEquityLevel" :ctrl="ctrlEquityLevel" :csData="dataEquityLevel"></cselect>

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('状态')}}</div>
				<cselect style="position:relative; height:30px; min-width:190px; z-index:999;" :defv="findStsDays" v-model="findStsDays" :ctrl="ctrlStsDays" :csData="dataWarnDays"></cselect>

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onDevListClick"></div>
			</div>
		</div>

		<div ref="idTablePan" style="width:100%; border:0px solid red; display:flex; align-items:center;">
			<ctable :ctrl="ctrlTable"></ctable>
		</div>

		<div style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red;">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>
	</div>
</template>

<script>

import ctable     from '../cf/ctable'
import popwin     from '../cf/popwin'
import cselect    from '../cf/cselect'
import cpage      from '../cf/cpage'

export default {
	name: 'validityWarn',
	components:{
		ctable, popwin, cselect, cpage
	},
	data () {
		return {
			keyFind: 1000,
			findCustName: "",                       // 客户名称
			findStsDays: "",
			ctrlStsDays:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},
			findEquityLevel: "",                    // 权益等级
			ctrlEquityLevel:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},
			findAuthType: 110,                      // 授权类型
			ctrlAuthType:{
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},
			ctrlPage: {
				havNote: true,                  //是否显示提示信息
				havGo: true,                    //是否显示页号输入及按钮
				total: 0,                       //总记录数
				pageSize: 10,                   //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:[this.getLangText('共'),this.getLangText('条记录,'),this.getLangText('页'),this.getLangText('条/页'),this.getLangText('页码'),'Go'],
				qryFunc: this.onDevListClick,      //查询回调函数
			},

			ctrlWin:{                               // 弹出窗口控制属性
				w2: 500,
				h2: 440,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				rcallFunc: this.onDevListClick,                 // 指定关闭弹出窗后需要执行的回调方法
			},
			ctrlTable: {                            // 表格控制参数
				headHeight: 50,                     // 表头行的高度
				dataHeight: 46,                     // 数据行的高度
				isCheck: false,                     // 第一列, 是否显示为复选框
				isSplit: false,                     // 固定列、数据列、操作列间是否有渐变分隔
				dataHeads:{                         // 表格表头定义
					head1:[                         // 固定列表头
						{ capt:this.getLangText("硬件编码"), width:300 },
					],
					head2:[                         // 数据列表头
						{ width:100, capt:this.getLangText('剩余天数') },
						{ width:120, capt:this.getLangText('有效期至') },
						{ width:120, capt:this.getLangText('权益等级') },
						{ width:100, capt:this.getLangText('授权方式') },
						{ width:100, capt:this.getLangText('状态') },
						{ width:250, capt:this.getLangText('客户名称') },
						{ width:200, capt:this.getLangText('设备型号') },
						{ width:200, capt:this.getLangText('添加时间') },
						{ width:200, capt:'' },
					],
					head3:[                         // 操作列表头
						{ capt:this.getLangText('操作'), width:110 },
					],
				},
				datas:{ data1:[ ], data2:[ ], data3:[ ] },  // 表格数据定义
			},
		}
	},
	mounted: function(){
		if( !parseInt(this.login.userId) ) return;

		this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

		this.ctrlTable.self.show();

		this.onDevListClick();
	},
	computed:{

	},
	methods:{
		onResize: function( ){
			this.$refs["idTablePan"].style["height"] = (this.$refs["idPan"].offsetHeight - 86)+"px";

			this.childResize( this );
		},
		/* 编辑按钮事件响应 */
		onEditClick: function( param ){
			this.ctrlWin.w2 = 500;
			this.ctrlWin.h2 = 470;
			this.ctrlWin.captCont = LangText("修改设备信息");
			this.ctrlWin.vuepath = "/FrameBody/devList/devInfo";
			this.ctrlWin.info=param;
			this.ctrlWin.self.onShow();
		},
		/* 移交按钮事件响应 */
		onDevoClick: function( param ){
			this.ctrlWin.w2 = 450;
			this.ctrlWin.h2 = 250;
			this.ctrlWin.captCont = LangText("移交设备");
			this.ctrlWin.vuepath = "/FrameBody/devList/devDevo";
			this.ctrlWin.info=param;
			this.ctrlWin.self.onShow();
		},
		/* 查询按钮事件响应 */
		onDevListClick: function(){
			let body={ pageSize:this.ctrlPage.pageSize, curPage:this.ctrlPage.pageIdx-1,
						custName: this.findCustName, stsDays: parseInt(this.findStsDays),
						devEquityLevel: parseInt(this.findEquityLevel),
						devAuthType: parseInt(this.findAuthType) };

			this.doTrade( "POST", ServAddr+"/api/device/warnList1", this.onDevListOK, true, body, null );
		},
		onDevListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.ctrlTable.datas.data1=[];
			this.ctrlTable.datas.data2=[];
			this.ctrlTable.datas.data3=[];

			for(let i=0; i<data.body.devList.length; i++ )
			{
				let item=data.body.devList[i];
				this.ctrlTable.datas.data1.push([ item.devHdcode ]);

				let daysDiff=item.daysDiff;
				let validate = this.splitYMD(item.devValidate, 1);
				if( daysDiff < 0 )
				{
					daysDiff = 0;
					validate = "<font style='color:#ff0000;'>"+validate+"</font>";
				}
				else if( daysDiff <= 7 )
				{
					validate = "<font style='color:#ed4e10;'>"+validate+"</font>";
				}

				this.ctrlTable.datas.data2.push( [ daysDiff, validate, this.getEquityText(item.devEquityLevel),
									this.getAutyTypeText(item.devAuthType), this.getDevStsText(item.devSts),
									item.custName, item.devSerialno, item.devAddDatetime.substring(0,19), '' ] );

				this.ctrlTable.datas.data3.push([ [  ] ]);
			}

			this.ctrlTable.self.show();
			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;
		},
		/* 删除模板类型 */
		onTMDelClick: function( params ){
			this.doTrade( "DELETE", ServAddr+"/api/template/tmDel/"+params.tmId, this.onTMDelOK, true, null, null );
		},
		onTMDelOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}
			this.onDevListClick();
		},
		/* 共享模板类型 */
		onTMShareClick: function( params ){

		},
		onTMShareOK: function( res ){

		},
		onTMModClick: function( params ){
			this.ctrlWin.captCont = LangText("修改模板类型");
			this.ctrlWin.info={ tmId: params.tmId, tmName: params.tmName };
			this.ctrlWin.self.onShow();
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// validityWarn.vue?0034f2ea